import { applyMiddleware, compose, createStore, type Store } from 'redux';
import { createEpicMiddleware } from 'redux-observable';

import rootEpic from './epics';
import rootReducer, { type AppState } from './reducer';

export default (): Store<AppState> => {
  // oxlint-disable-next-line typescript/no-explicit-any -- Required for Redux-Observable Epic type compatibility
  const epicMiddleware = createEpicMiddleware<any, any, AppState>();
  const composeEnhancers =
    (typeof window !== 'undefined' &&
      (window as { __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: typeof compose }).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
    compose;
  const enhancer = composeEnhancers(applyMiddleware(epicMiddleware));

  const store = createStore(rootReducer, enhancer);

  epicMiddleware.run(rootEpic);

  // oxlint-disable-next-line typescript/no-explicit-any -- Required for Redux store type compatibility
  return store as any;
};
